import React, { useEffect, useState } from 'react';
import { fetchEarnings, fmtMoney } from '../lib/earnings';

/**
 * EarningsKPI — a compact KPI tile matching the existing dashboard
 * tile aesthetic (label + big number + small delta line).
 *
 * Deliberately minimalist:
 *   - Always "this week" (per spec, dashboard has no filter — analysts
 *     go to /analytics for anything longer).
 *   - No chart, no dropdown.
 *   - Cash/card split renders as the small caption line under the value.
 *
 * Props:
 *   shopId      — required
 *   barberId    — optional; when set the tile is scoped to that barber
 *   label       — tile title
 *   dataTestId  — root testid
 */
export const EarningsKPI = ({ shopId, barberId = null, label, dataTestId = 'earnings-kpi' }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ total: 0, cash: 0, card: 0, count: 0 });

  useEffect(() => {
    if (!shopId) return;
    let cancelled = false;
    setLoading(true);
    fetchEarnings({ shopId, barberId, period: 'week' })
      .then(r => { if (!cancelled) { setData(r); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [shopId, barberId]);

  const caption = data.total === 0 && !loading
    ? 'nothing yet this week'
    : `Cash ${fmtMoney(data.cash)} · Card ${fmtMoney(data.card)}`;

  return (
    <div className="kpi" data-testid={dataTestId}>
      <div className="t">{label}</div>
      <div className="v" data-testid={`${dataTestId}-value`}>
        {loading ? '—' : fmtMoney(data.total)}
      </div>
      <div className="d flat" data-testid={`${dataTestId}-split`}>
        {loading ? '—' : caption}
      </div>
    </div>
  );
};

export default EarningsKPI;
